import { ShieldAlert, LogOut } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { ChangePasswordForm } from "@/components/ChangePasswordForm";

export default function ForceChangePassword({ onDone }) {
  const { user, logout, refreshMe } = useAuth();

  const handleSuccess = async () => {
    await refreshMe();
    onDone?.();
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-mist px-6 py-10" data-testid="force-change-password">
      <div className="w-full max-w-md rounded-2xl border border-sky/70 bg-white p-8 shadow-xl shadow-navy/10">
        <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-loop/10">
          <ShieldAlert className="h-6 w-6 text-loop" />
        </div>
        <h1 className="mt-5 font-sora text-2xl font-bold text-navy">Set a new password</h1>
        <p className="mt-1.5 text-sm text-ink/60">
          For security, you must set a new password before you can continue. Signed in as <span className="font-medium text-navy">{user?.email}</span>.
        </p>

        <div className="mt-6">
          <ChangePasswordForm forced onSuccess={handleSuccess} submitLabel="Set password & continue" />
        </div>

        <button onClick={logout} data-testid="force-change-logout"
          className="mt-5 flex w-full items-center justify-center gap-2 text-xs font-medium text-ink/50 hover:text-ink/80">
          <LogOut className="h-3.5 w-3.5" />Sign out instead
        </button>
      </div>
    </div>
  );
}
